import { TipoPedidoAlerta } from '../shared/enums/tipo-pedido-alerta.enum';

export class PedidoAlerta {
    constructor(
        public tipo: TipoPedidoAlerta,
        public exibir: boolean,
        public dataExpiracao: Date
    ) { }
}
